"use strict";

var curry = require("../Strict/curry.js");

var toIter = require("../Strict/toIter.js");

var go = require("../Strict/go.js");

var take = require("../Strict/take.js");

var rangeL = require("./rangeL.js");

var mapL = require("./mapL.js");

var takeWhileL = require("./takeWhileL.js");

module.exports = curry(function chunkL(n, iter) {
  iter = toIter(iter);
  return go(rangeL(Infinity), mapL(_ => take(n, iter)), takeWhileL(c => c.length));
});